export default "https://cdn-static.gokick.com/assets/b4422e726e3b42ca3d48f0d34192932f5b3fbcfa/images/sleep-bottles.21ff427124b73aa7b2cf5884e65ef589.jpg";